var App = App || {};

App.BlogMainMasthead = (function ($) {
    "use strict";

    function init() {

        const blogmainMasthead = $(".blog-main-masthead");
        if (blogmainMasthead.length) {
            blogmainMasthead.each(function () {
                InitCarousels($(this));
            });
        }
    }

    function InitCarousels(blogmainMasthead) {
        const carousel = blogmainMasthead.find(".splide");

        if (carousel.length) {
            const splideCarousel = new Splide(carousel[0], {
                pagination: false,
                type: 'loop',
                fixedWidth: "339px",
                gap: "20px",
                drag: true,
                snap: false,
                perMove: 1,
                breakpoints: {
                    991: {
                        fixedWidth: "237px",
                        gap: "10px",
                    },
                }
            });

            splideCarousel.mount();

            const nextBtn = blogmainMasthead.find(".carousel-btn.carousel-next");
            const prevBtn = blogmainMasthead.find(".carousel-btn.carousel-prev");

            nextBtn.on("click", function () {
                splideCarousel.go('+1');
            });

            prevBtn.on("click", function () {
                splideCarousel.go('-1');
            });
        }
    }

    return {
        init: init
    };

})(jQuery);

$(function () {
    App.BlogMainMasthead.init();
});